// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import DispatchDesk from './pages/DispatchDesk';
import SmartIndex from './pages/SmartIndex';
import Insights from './pages/Insights';        // placeholder we’ll create next
import Research from './pages/Research';        // placeholder we’ll create next

import useSessionTracker from './analytics/useSessionTracker';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', color: 'red' }}>
          <h2>Something broke in this view</h2>
          <p>{this.state.error?.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useSessionTracker();

  return (
    <BrowserRouter>
      <nav style={{display:'flex', gap:12, padding:12, borderBottom:'1px solid #eee'}}>
        <Link to="/">Dispatch Desk</Link>
        <Link to="/smart-index">Smart Index</Link>
        <Link to="/insights">Insights</Link>
        <Link to="/research">Research</Link>
      </nav>

      <Routes>
        <Route path="/" element={<ErrorBoundary><DispatchDesk /></ErrorBoundary>} />
        <Route path="/smart-index" element={<ErrorBoundary><SmartIndex /></ErrorBoundary>} />
        <Route path="/insights" element={<ErrorBoundary><Insights /></ErrorBoundary>} />
        <Route path="/research" element={<ErrorBoundary><Research /></ErrorBoundary>} />
      </Routes>
    </BrowserRouter>
  );
}
